import { useLastPathSegment } from 'shared/hooks'
import { type LocalNumbersRoutes } from 'pages/settings/pages/compliance/pages/localNumbers'

export const usePathSegment = () => {
  return useLastPathSegment() as LocalNumbersRoutes
}
